<template>
  <b-modal
    id="delete-extra-payment-modal"
    title="Delete Extra Payment Category"
  >
    <h4 class="text-center">
      Are you sure you want to delete {{ categoryName }}?
    </h4>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            :disabled="submitting"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="deleteHandler"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol,
  },
  props: {
    category: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const toast = useToast()
    const submitting = ref(false)
    
    const deleteHandler = async () => {
      try {
        submitting.value = true
        await axiosIns.delete(`/bills/extra/categories/${props.category.id}`)
        toast.success('Category deleted successfully')
        ctx.emit('deleted')
        ctx.root.$bvModal.hide('delete-extra-payment-modal')
      } catch (error) {
        console.error('Error deleting category:', error)
        toast.error(error.response?.data?.message || 'Failed to delete category')
      } finally {
        submitting.value = false
      }
    }
    
    const categoryName = computed(() => props.category?.name || 'this category')
    
    return {
      submitting,
      deleteHandler,
      categoryName,
    }
  },
}
</script>

<style>

</style>
